var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.added > 0)?_c('div',{staticClass:"numCartItems full"},[_vm._v("Positionen: "+_vm._s(_vm.added))]):_c('div',{staticClass:"numCartItems"},[_vm._v(_vm._s(_vm.added))])
}
var staticRenderFns = []

export { render, staticRenderFns }